module.exports = __webpack_public_path__ + "img/noFile.9ac8bbbd.jpg";